import React, { useState, useEffect, useCallback } from 'react'
import { throttle } from 'lodash'
import { useHistory } from 'react-router-dom'
import { getAirportList } from '../_services/airport'
import moment from 'moment'
import useQuery from '../hooks/useQuery'

const bookingTypeList = ['Cold bed', 'Hot bed']

export function MobileNavOptions({ setGlobalBookingType }) {
    const query = useQuery()
    const history = useHistory()
    const [airportDetails, setAirportDetails] = useState({
        name: '',
        iata: '',
    })
    const [checkin, setCheckin] = useState(query.get('checkIn') || new Date().toISOString().split('T')[0])
    const [checkout, setCheckout] = useState(query.get('checkOut') || checkin)
    const [iataCode, setIataCode] = useState(query.get('iata') || '')
    const [airportlist, setAirportList] = useState([])
    const [propertyOption, setPropertyOption] = useState(false)
    const [bookingType, setBookingType] = useState(query.get('bookingType') || 'Cold bed')

    const fetchAirport = async (term) => {
        try {
            setAirportList([])
            getAirportList(
                term,
                (data) => {
                    setAirportList(data.airports)
                    setAirportDetails(data)
                },
                (data) => {
                    setAirportList([])
                    setAirportDetails({ name: '' })
                }
            )
        } catch (error) {}
    }

    const throtteledFetchAirport = useCallback(throttle(fetchAirport, 500), [])

    function handleAirportFetch(e) {
        setIataCode(e.target.value.toUpperCase())
        throtteledFetchAirport(e.target.value.toUpperCase())
    }

    function handleSearchProperty() {
        let params
        if (iataCode) {
            params = new URLSearchParams({
                iata: iataCode,
                bookingType,
                airportName: airportDetails.name,
                checkIn: checkin,
                checkOut: checkout,
            })
        } else
            params = new URLSearchParams({
                bookingType,
                checkIn: checkin,
                checkOut: checkout,
            })

        // history.push({
        //   pathname: `/property-listing?${params.toString()}`,
        //   state: {
        //     airportDetails,
        //   },
        // });

        history.replace(`/property-listing?${params.toString()}`)
    }

    useEffect(() => {
        setCheckin(query.get('checkIn') || new Date().toISOString().split('T')[0])
        if (query.get('checkOut')) {
            setCheckout(query.get('checkOut'))
        }

        // if (!query.get("iata")) {
        //   setIataCode("");
        //   setAirportDetails({ name: "", iata: "" });
        // }

        // if (query.get("bookingType")) {
        //   setBookingType(query.get("bookingType"));
        // } else {
        //   setBookingType("Hot bed");
        // }
    }, [query])

    useEffect(() => {
        const tommorow = new Date(checkin)
        tommorow.setDate(new Date(checkin).getDate() + 1)
        if (!query.get('checkOut') || new Date(checkout) - new Date(checkin) <= 0) {
            setCheckout(tommorow.toISOString().split('T')[0])
        }
    }, [checkin])

    return (
        <div className="md:hidden block">
            <div className=" md:hidden grid grid-cols-2 gap-x-4 rounded-md ring-0 ring-primary-blue ring-opacity-40 p-3 text-primary-blue">
                <div>
                    <p className="text-sm font-bold">Airport Code</p>
                    <input
                        value={iataCode}
                        onChange={handleAirportFetch}
                        placeholder="Airport Code"
                        // maxLength={4}
                        className="cursor-pointer   placeholder-gray-500 pr-2 flex-grow text-xs  bg-transparent outline-none"
                    />
                    <div className="relative ">
                        {Boolean(airportlist.length) && (
                            <div className="absolute top-0 py-2  text-white left-0 right-0 z-50  rounded bg-primary-blue">
                                {airportlist.map((curr, ind) => (
                                    <p
                                        key={ind}
                                        onClick={() => {
                                            setIataCode(curr.iata)
                                            setAirportList([])
                                            setAirportDetails({ ...curr })
                                        }}
                                        className="p-2 text-xs cursor-pointer hover:bg-opacity-40 hover:bg-gray-900"
                                    >
                                        {curr.iata}, {curr.name}
                                    </p>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
                <div className=" relative" onClick={() => setPropertyOption(!propertyOption)}>
                    <p className="text-sm font-bold">Booking type</p>
                    <select
                        value={bookingType}
                        onChange={(e) => {
                            setBookingType(e.target.value)

                            if (setGlobalBookingType) {
                                setGlobalBookingType(e.target.value)
                            }
                        }}
                        className="text-xs cursor-pointer pr-2 w-full flex-grow border-0  bg-transparent outline-none rounded ring-0 focus:ring-0 focus:outline-none"
                    >
                        <option value="" disabled>
                            Select Booking type
                        </option>
                        {bookingTypeList.map((curr, ind) => (
                            <option key={ind} value={curr}>
                                {curr}
                            </option>
                        ))}
                    </select>
                </div>
                <div>
                    <p className="text-sm font-bold">Check In</p>
                    <input
                        value={checkin}
                        onChange={(e) => setCheckin(e.target.value)}
                        min={new Date().toISOString().split('T')[0]}
                        type="date"
                        className="outline-none text-xs ring-0 border-0 p-0 focus:ring-0 focus:border-0"
                    />
                </div>
                <div>
                    <p className="text-sm font-bold">Check Out</p>
                    <input
                        value={checkout}
                        onChange={(e) => setCheckout(e.target.value)}
                        min={new Date(moment(new Date(checkin)).add(1, 'day')).toISOString().split('T')[0]}
                        type="date"
                        className="outline-none text-xs ring-0 border-0 p-0 focus:ring-0 focus:border-0"
                    />
                </div>
            </div>
            <button onClick={handleSearchProperty} className="px-5 w-44 p-2 rounded-full bg-primary-blue text-white font-medium   text-sm  ">
                SEARCH
            </button>
        </div>
    )
}
